import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en_NZ from './locales/global/en-NZ.json';
import mi_NZ from './locales/global/mi-NZ.json';

export const defaultNS = 'global';
i18n.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		debug: process.env.NODE_ENV !== 'production',
		fallbackLng: 'en-NZ',
		ns: [defaultNS],
		resources: {
			'en-NZ': {
				global: en_NZ,
			},
			'mi-NZ': {
				global: mi_NZ,
			},
		},
		interpolation: {
			// react already saves from xss
			escapeValue: false,
		},
		defaultNS: defaultNS,
		fallbackNS: 'global',
	});

export default i18n;
